import Button from '@mui/material/Button';
import React, {useState} from 'react';
import PropTypes from 'prop-types';

function ButtonComp(props) {
  const {
    variant,
    value,
    onClick,
    startIcon,
    endIcon,
    className,
    backgroundColor,
    height,
    fontSize,
    padding,
    fontWeight,
    disabled = false,
    textcolor,
    btnClass,
    borderRadius,
    width,
    marginRight,
    customStyle,
    type,
    minWidth,
    maxHeight,
    alignItems,
    display,
    marginTop,
    boxShadow,
    border,
    hoverbackgroundColor,
    gradient,
    removeDelay = false,
    ...other
  } = props;

  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
    if (!removeDelay) {
      setIsDisabled(true);
      setTimeout(() => {
        setIsDisabled(false);
      }, 500);
    }
  };

  const buttonStyle = {
    width: width || 'auto',
    height: height || 'auto',
    fontSize: fontSize || '',
    fontWeight: fontWeight || '',
    marginRight: marginRight || 'none',
    borderRadius: borderRadius || '',
    background: gradient || backgroundColor || 'transparent',
    color: textcolor || 'inherit',
    padding: padding,
    textTransform: 'none',
    minWidth: minWidth || 'none',
    maxHeight: maxHeight || 'none',
    display: display || '',
    alignItems: alignItems || 'none',
    marginTop: marginTop || 'none',
    border: border || 'none',
    ...customStyle,
    '&:hover': {
      background: hoverbackgroundColor || gradient || backgroundColor,
    },
    '&.Mui-disabled': {
      backgroundColor: 'linear-gradient(168deg, #F37021 100%, #FDBA12 100%)',
      opacity: '0.7',
      color: textcolor,
    },
    '&.MuiButton-outlined': {
      borderColor: ' #F37021 ',
    },
    boxShadow: boxShadow || 'none',
  };

  return (
    <Button
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick ? handleClick : onClick}
      className={btnClass}
      sx={{...buttonStyle}}
      disabled={isDisabled || disabled}
      type={type}
      {...other}>
      <span className={className}>{value}</span>
    </Button>
  );
}

ButtonComp.propTypes = {
  variant: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  height: PropTypes.string,
  fontSize: PropTypes.string,
  padding: PropTypes.string,
  fontWeight: PropTypes.string,
  disabled: PropTypes.bool,
  textcolor: PropTypes.string,
  borderRadius: PropTypes.string,
  width: PropTypes.string,
  marginRight: PropTypes.string,
  customStyle: PropTypes.object,
  type: PropTypes.string,
  minWidth: PropTypes.string,
  btnClass: PropTypes.string,
  maxHeight: PropTypes.string,
  alignItems: PropTypes.string,
  display: PropTypes.string,
  marginTop: PropTypes.string,
  boxShadow: PropTypes.string,
  border: PropTypes.string,
  hoverbackgroundColor: PropTypes.string,
  gradient: PropTypes.string,
  removeDelay: PropTypes.any,
};

export default ButtonComp;
